import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, provide } from 'vue'
import { injectKeyRadioGroupValue } from '@/types/injectKey'

import ButtonGroup from './ButtonGroup.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioGroup',
  props: {
    value: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:value"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const updateValue = (value: string) => {
  if (props.disabled) return
  emit('update:value', value)
}

const value = computed(() => props.value)

provide(injectKeyRadioGroupValue, {
  value,
  updateValue,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonGroup, { class: "radio-group" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})